<script>
  const calcPos = (circle) => {
    if(circle) {
      return [
        circle.x + circle.w * 0.2,
        circle.y + circle.h * 0.7
      ];
    }
    else {
      return [0, 0];
    }
  }

  export default {
    name: 'Walker',
    data() {
      const n = (this.$store.state.answeredIds.length < 19 ? this.$store.state.answeredIds.length : 19);
      const { circles } = this.$store.state;

      return {
        startPos: calcPos(circles[n]),
        endPos: calcPos(circles[n + 1]),
        alphaPos: 0,
        step: 0,
        timePrev: 0,
        time: 0,
        duration: 1000,
      }
    },
    computed: {
      styles() {
        const x = (this.endPos[0] - this.startPos[0]) * this.alphaPos + this.startPos[0];
        const y = (this.endPos[1] - this.startPos[1]) * this.alphaPos + this.startPos[1];
        const direction = (this.endPos[0] - this.startPos[0]) / Math.abs(this.endPos[0] - this.startPos[0]);
        const degY = (direction < 0) ? (180 * (direction * 0.5 - 0.5) + 360) : (180 * (direction * 0.5 - 0.5));
        return {
          backgroundPosition: `${this.step % 4 * -90}px, 0`,
          top: `${y / 362 * 100}%`,
          left: `${x / 375 * 100}%`,
          transform: `rotateY(${degY}deg)`
        }
      }
    },
    mounted() {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'toggleModalStamp' && mutation.payload === false) {
          const n = (this.$store.state.answeredIds.length < 20 ? this.$store.state.answeredIds.length : 20);
          const { circles } = this.$store.state;
          if(n < 20) {
            this.startPos = calcPos(circles[n - 1]);
            this.endPos = calcPos(circles[n]);
            this.alphaPos = 0;
            this.timePrev = Date.now();
            this.time = 0;
            this.update();
          }
        }
      });
    },
    methods: {
      update() {
        const thisTime = Date.now();
        this.time += thisTime - this.timePrev;
        this.timePrev = thisTime;
        this.step = Math.min(Math.floor(this.time / this.duration * 4), 4);
        this.alphaPos = Math.min(this.time / this.duration, 1);
        if (this.time < this.duration) {
          requestAnimationFrame(this.update);
        }
      }
    }
  }
</script>

<template lang="pug">
  .walker(
    :style = 'styles'
    )
</template>

<style lang="scss">
  .walker {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 110;
    margin-top: -45px;
    margin-left: -45px;
    pointer-events: none;
    background-image: url('~@/assets/img/walk_sprite.png');
    background-size: 360px 90px;
  }
</style>
